import React from 'react'
import { AggregateListItem, Divider, InfoBox, List, ListSubheader } from 'components'
import { formatCurrency } from '../../../../../utils/currency'
import styles from './PortfolioTerminationForm.module.scss'

interface NextStepsProps {
  cancellationFee: number
}

const NextSteps = ({ cancellationFee }: NextStepsProps) => {
  return (
    <InfoBox type="locked" className={styles['info-box']}>
      <h3>Termination summary</h3>
      <List className={styles.summary}>
        <ListSubheader>Immediately</ListSubheader>
        <AggregateListItem text="Send lease termination email to owner" />
        <AggregateListItem text="Send lease termination email to tenant" />
        <AggregateListItem text="Send lease termination email to agent" />
        <ListSubheader>The following draft invoices will be generated</ListSubheader>
        <AggregateListItem text="Cancellation fee">
          <span>{formatCurrency(cancellationFee)}</span>
        </AggregateListItem>
      </List>
    </InfoBox>
  )
}

export default NextSteps
